module.exports = __webpack_public_path__ + "static/media/golfer-5-b.06aafbc6.png";